import jquery from "jquery";
window.$ = window.jQuery = jquery;
import Flickity from 'flickity';

const selectors = {
    slider: '[data-section-type="benefit-bar"] .benefit-bar__inner',
}

jQuery(function() {
    if($(window).outerWidth() < 769 ){
        const $carousel = $(selectors.slider);
        if (!!$carousel.length) {
            var flkty = new Flickity( selectors.slider, {
                pageDots: false,
                prevNextButtons: false,
                wrapAround: true,
                resize: false,
                draggable: false,
                fade: 'fade',
                cellAlign: 'left',
                adaptiveHeight: true,
                autoPlay: 4000,
                selectedAttraction: 0.2,
                friction: 0.8
            });
        }    
    }
})
//check if the review item is set
function reviewStars() {
 const reviewsioUrlKey = "junoandme.de";
    $.ajax({
        url:"https://api.reviews.io/timeline/data?per_page=15&type=store_review&include_local_reviews=false&include_product_reviews=true&sort=date_desc&minRating=4&tag=&store=" + reviewsioUrlKey,
        success: function(result){ 
        const reviewsIoRating = parseFloat(result.stats.average_rating);
        const reviewText = document.querySelectorAll('.benefit-bar__rating')[0]
        if(!!reviewText){
            reviewText.innerHTML = reviewText.innerHTML.replace('{rating}', reviewsIoRating.toFixed(2) + "/5")
        }
        //Creating span and append the icons to it
        let done = false;
        document.querySelectorAll('.RatingStars').forEach((e, i) =>{
            const result = reviewsIoRating % (i + 1);
            let svgRect = e.querySelector('#Rectangle')
            //spliting the rating and to get the last digit
            const lastNumber = result.toString().split('.');
            
            if(result == reviewsIoRating && done == false){
                if( result < 0.5 ){
                    svgRect.setAttribute("width", "100%");
                } else if (Math.round(lastNumber[1]) < 7 && Math.round(lastNumber[1]) > 4 ){
                    svgRect.setAttribute("width", "50%");
                } else if(Math.round(lastNumber[1]) < 5){
                    svgRect.setAttribute("width", "35%"); 
                } else if(Math.round(lastNumber[1]) >= 7){
                    svgRect.setAttribute("width", "65%");
                } else {
                    svgRect.setAttribute("width", "0%");
                } 
                done = true  
            } else if(done == true){
                svgRect.setAttribute("width", "0%");
            } else {
                svgRect.setAttribute("width", "100%");
            }  
        })
    },
    error: function(error){
        console.log(error);
      }
    })
}    
document.addEventListener("DOMContentLoaded", function () {
    reviewStars()
});   